import React, { Component } from 'react';
import { Link } from 'react-router-dom';

export default class Default extends Component {
  render() {
    return (
      <div className="unknownPage">
        <h1>404</h1>
        <h1>ERROR</h1>
        <h2>PAGE NOT FOUND</h2>
        <h3>The requested URL <strong>{this.props.location.pathname}</strong> was not found</h3>
        <Link to="/">
          <button>Return To Store</button>
        </Link>
      </div>
    )
  }
}
